<template>
  <div class="advance-filter-panel">
    <DxToolbar class="split-view-toolbar">
      <dx-item
        location="before"
        widget="dxTabs"
        :options="filterPanelTabOptions"
        :selected-index.sync="sidebarTabSelectedIndex"
      ></dx-item>

      <DxItem :options="toolbar.close" location="after" widget="dxButton" />
    </DxToolbar>

    <div v-show="sidebarTabSelectedIndex == 0">
      <div class="view-card responsive-paddings">
        <!-- <DxScrollView
          id="filter-scrollview"
          :show-scrollbar="'always'"
          :scroll-by-content="true"
          :scroll-by-thumb="true"
          :height="filterFormHeight"
        > -->
        <form>
          <div class="header-btns">
            <DxButton
              class="apply-btn"
              :text="applyButtonLabel"
              type="default"
              @click="applyCustomFilter"
            />
            <DxButton text="clear" type="normal" @click="clearAdvanceFilters" />
          </div>

          <DxForm
            :form-data="reportModel"
            :show-colon-after-label="false"
            :show-required-mark="false"
            :show-validation-summary="false"
            :scrolling-enabled="true"
            :height="setFilterFormHeight - 35"
            :validation-group="'advance-filter-form'"
            :col-count-by-screen="{
              xs: 1,
              sm: 1,
              md: 1,
              lg: 1,
            }"
            label-location="top"
            :items.sync="jSonFormItems"
            ref="filter-form"
            @fieldDataChanged="formInitialized"
          >
            <!-- <template #FilterAutoComplete="{ data }">
              <ReportGridAutoComplete
                :on-value-changed="createCustomFilter"
                :data-options="getOptions(data.dataField)"
              />
            </template>

            <template #FilterTagBox="{ data }">
              <ReportGridTagBox
                :on-value-changed="createCustomFilter"
                :data-options="getOptions(data.dataField)"
              />
            </template>

            <template #TextBoxEditor="{ data }">
              <DxTextBox
                @value-changed="createCustomFilter(data.dataField, $event)"
              />
            </template> -->

            <template #deliveryAddressTemplate="{ data }">
              <div class="custom-auto-complete data-grid">
                <span class="auto-complete-primary">
                  {{ data.CompanyName }}
                </span>
                <div class="auto-complete-secondary no-padding">
                  <span v-if="data.PhysicalAddressStreetLine1 != ''">
                    {{ data.PhysicalAddressStreetLine1 }}
                  </span>
                  <span v-if="data.PhysicalAddressStreetLine2 != ''">{{
                    data.PhysicalAddressStreetLine2
                  }}</span>
                  <span v-if="data.PhysicalAddressSuburb != ''">{{
                    data.PhysicalAddressSuburb
                  }}</span>
                  <span v-if="data.PhysicalAddressState != ''">{{
                    data.PhysicalAddressState
                  }}</span>
                  <span v-if="data.PhysicalAddressPostcode != ''">{{
                    data.PhysicalAddressPostcode
                  }}</span>
                </div>
              </div>
            </template>

            <template #item-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Description"
                :code="data.Code"
              />
            </template>
            <!-- <template #computed-item-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Description"
                :code="data.ComputedStringCode"
              />
            </template>
            <template #location-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Location"
                :code="data.Code"
              />
            </template>
            <template #supplier-item-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Name"
                :code="data.Code"
              />
            </template>
            <template #currency-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Description"
                :code="data.CurrencyCode"
              />
            </template>

            <template #transaction-type-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.TransactionTypeDescription"
                :code="data.TransactionType"
              />
            </template>
            <template #sub-code-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Name"
                :code="data.Code"
              />
            </template> -->

            <!-- from invoce report  -->
            <template #date-group-items="{ data }">
              <div>
                <!-- <span class="custom-word-wrap">{{ data.text }}</span> -->
                <div class="custom-auto-complete">
                  <span class="auto-complete-primary">{{ data.text }}</span>
                  <span class="auto-complete-secondary">{{
                    data.secondaryText
                  }}</span>
                </div>
              </div>
            </template>
            <!-- <template #filterCustomerTemplate="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Name"
                :code="data.Code"
              />
            </template>

            <template #rep-item-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.FirstName + ' ' + data.Surname"
                :code="data.Code"
              />
            </template>
            <template #product-item-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Description1"
                :code="data.Code"
              />
            </template>
            <template #product-cell-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Description"
                :code="data.ItemCode"
              />
            </template>
            <template #bin-location-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.Location"
                :code="data.Code"
              />
            </template>
            <template #site-template="{ data }">
              <GcAutoCompleteItemTemplate
                :description="data.SiteName"
                :code="data.SiteCode"
              />
            </template> -->
            <template #date-in-template="{ data }">
              <div>
                <DxDateBox
                  :value="reportModel[data.dataField]"
                  @valueChanged="data.editorOptions.onValueChanged"
                  display-format="dd MMM yyyy"
                  :max="reportModel[data.dataField + 'To']"
                >
                  <DxDateBoxButton
                    :options="searchTypes"
                    name="search"
                    location="before"
                  />
                  <DxDateBoxButton
                    name="clear-btn"
                    :options="dateInClearBtn"
                    location="after"
                  />
                  <DxDateBoxButton name="dropDown" />

                  <template #date-in-clear>
                    <div>
                      <span
                        class="dx-clear-button-area"
                        @click="clearDateIn(data.dataField)"
                        ><span class="dx-icon dx-icon-clear"></span
                      ></span>
                    </div>
                  </template>

                  <template #show-drop-down>
                    <div>
                      <DxDropDownButton
                        class="search-option"
                        :icon="
                          searchOperatorIconModel[data.dataField]
                            ? searchOperatorIconModel[data.dataField]
                            : 'equal'
                        "
                        :showArrowIcon="false"
                        :stylingMode="'text'"
                        :items="filterDateRangeOptions(data)"
                        keyExpr="value"
                        displayExpr="text"
                        :drop-down-options="{ width: 250 }"
                        :onItemClick="searchOptionItemClick.bind(this, data)"
                        :useSelectMode="true"
                        :selectedItemKey="getDateRangeModel[data.dataField]"
                      >
                      </DxDropDownButton>
                    </div>
                  </template>
                </DxDateBox>
              </div>
            </template>

            <template #date-in-to-template="{ data }">
              <div class="date-in-to">
                <span>To</span>
                <DxDateBox
                  :value="reportModel[data.dataField]"
                  @valueChanged="data.editorOptions.onValueChanged"
                  @optionChanged="optionChanged($event, data)"
                  display-format="dd MMM yyyy"
                  width="135"
                  :min="
                    reportModel[data.dataField.toString().replace('To', '')]
                  "
                  :showClearButton="data.editorOptions.showClearButton"
                >
                </DxDateBox>
              </div>
            </template>

            <template #tag-box-template="{ data }">
              <div>
                <DxTagBox
                  :data-source="data.editorOptions.dataSource"
                  :on-value-changed="data.editorOptions.onValueChanged"
                  :display-expr="data.editorOptions.displayExpr"
                  :value-expr="data.editorOptions.valueExpr"
                  :searchEnabled="data.editorOptions.searchEnabled"
                  :searchMode="data.editorOptions.searchMode"
                  :searchExpr="data.editorOptions.searchExpr"
                  :itemTemplate="data.editorOptions.itemTemplate"
                  :showClearButton="data.editorOptions.showClearButton"
                  :value="reportModel[data.dataField]"
                  @valueChanged="tagBoxValueChanged($event, data)"
                  :openOnFieldClick="true"
                >
                  <!-- <template #CustomRepTemplate="{ data }">
                    <GcAutoCompleteItemTemplate
                      :description="data.FirstName + ' ' + data.Surname"
                      :code="data[secondaryText]"
                    />
                  </template>

                  <template #CustomTemplate="{ data }">
                    <GcAutoCompleteItemTemplate
                      :description="data[primaryText]"
                      :code="data[secondaryText]"
                    />
                  </template> -->
                  <template #item-template-2="{ data:item }">
                    <GcAutoCompleteItemTemplate
                      :description="item[data.editorOptions.primaryText]"
                      :code="item[data.editorOptions.secondaryText]"
                      :data="data"
                    />
                  </template>
                </DxTagBox>
              </div>
            </template>
          </DxForm>
        </form>
        <!-- </DxScrollView> -->
      </div>
    </div>

    <DxPopup
      :visible.sync="tabletModeSelectPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :title="tabletModeSelectPopupTitle"
      :showCloseButton="false"
      :width="800"
      :height="600"
      @hidden="customePopUpHidden"
    >
      <dx-data-grid
        :data-source="tabletModeDataSourceConfig"
        :show-column-headers="showColumnHeaders"
        :selection="{ mode: 'multiple' }"
        :height="430"
        :columns="columns"
        :ref="'custom-popup-grid'"
        :selected-row-keys.sync="selectedRowKeys"
        @content-ready="onContentReady"
        @toolbar-preparing="selectPopUpToolbarPreparing($event)"
        @row-click="customePopUpRowClick"
        :allow-column-reordering="false"
        :keyExpr="keyExpr"
      >
        <DxSelection
          :select-all-mode="'allPages'"
          :show-check-boxes-mode="'always'"
          :mode="'multiple'"
        />

        <DxSearchPanel
          :visible="true"
          :highlight-case-sensitive="true"
          :text.sync="searchText"
        />

        <template #customer-cell-template="{ data }" class="customer-cell">
          <div class="toolbar-auto-complete">
            <span class="title">{{ data.data.Name }}</span>
            <span class="sub-title" style="color: grey">{{
              data.data.Code
            }}</span>
          </div>
        </template>

        <template #sales-rep-cell-template="{ data }">
          <div>
            <div class="toolbar-auto-complete">
              <span class="title">{{
                data.data.FirstName + " " + data.data.Surname
              }}</span>
              <span class="sub-title" style="color: grey">{{
                data.data.Code
              }}</span>
            </div>
          </div>
        </template>
      </dx-data-grid>
      <div class="footer">
        <DxButton
          text="Ok"
          type="default"
          styling-mode="contained"
          @click="applyPopUpFilter"
        />
      </div>
    </DxPopup>
  </div>
</template>
<script>
/* eslint-disable no-console */
// import ReportGridAutoComplete from "./rp-grid-autocomplete";
// import ReportGridTagBox from "./rp-grid-tagbox";

// var stringifyDate = require("json-stringify-date");
var replacer = function(key, value) {
  if (this[key] instanceof Date) {
    return this[key].toUTCString();
  }

  return value;
};

import BaseViewMixin from "../../v1/_mixins/base.view";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";

import ReportLayOut from "../../views/reports/report-layouts";
import DxTagBox from "devextreme-vue/tag-box";

import {
  DxDateBox,
  DxButton as DxDateBoxButton,
} from "devextreme-vue/date-box";
export default {
  mixins: [BaseViewMixin],
  components: { DxDateBox, DxDateBoxButton, DxTagBox },
  props: {
    advanceFilterArray: {
      type: Array,
      default: () => [],
    },
    dirty: {
      type: Object,
      default: () => {
        return { isDirty: false };
      },
    },
    toolbar: {
      type: Object,
      default: () => {},
    },
    filterCallBack: {
      type: Function,
      default: () => {},
    },
    filterFormItems: {
      type: Array,
      default: () => [],
    },
    filterModel: {
      type: Object,
      default: undefined,
    },
    isJson: {
      type: Boolean,
      default: true,
    },
    screenType: {
      type: String,
      default: "home",
    },
    dataSourceConfig: {
      type: Object,
      default: undefined,
    },
    applyFilter: {
      type: Function,
      default: undefined,
    },
    initialFilter: {
      type: Array,
      default: () => [],
    },
    setFilterFormHeight: {
      type: [String, Number],
    },
    defaultValue: {
      type: Object,
      default: undefined,
    },
    dateRangeModel: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      dataSource: this.dataSourceConfig,
      showFilterForm: true,
      items: [
        {
          itemType: "group",
          caption: "",
          items: [],
        },
      ],
      sidebarTabSelectedIndex: 0,
      model: this.reportModel,
      tabletModeSelectPopupVisible: false,
      tabletModeDataSourceConfig: {},
      showColumnHeaders: false,
      selectedRowKeys: [],
      tabletViewSelectColumns: [],
      tabletModeSelectPopupTitle: "Search",
      keyExpr: undefined,
      tabletModeSelectedField: undefined,
      searchText: undefined,
      searchTypes: {
        // icon: this.selectSearchicon,
        template: "show-drop-down",
        elementAttr: { class: "search-option-drop-down" },
        // onClick: () => {
        //   // this.dateValue = new Date().getTime();
        // }
      },
      dateClear: {
        icon: "clear",
        type: "clear",
        template: "date-in-clear",
        elementAttr: { class: "date-in-clear dx-clear-button-area" },
        visible: false,
      },
      searchOptionItems: [
        { icon: "equal", text: "Equals", value: "=" },
        { icon: "less", text: "Less than", value: "<" },
        { icon: "greater", text: "Greater than", value: ">" },
        { icon: "lessorequal", text: "Less than or equal to", value: "<=" },
        {
          icon: "greaterorequal",
          text: "Greater than or equal to",
          value: ">=",
        },
        { icon: "range", text: "Between", value: "between" },
      ],
      selectedSearchOptionIcon: "equal",
      selectedSearchOption: "=",
      searchOperatorIconModel: {},
    };
  },
  created() {
    console.log("filterFormItems ", this.filterFormItems);
    // console.log('AAA ', ReportLayOut.getReportLayout("Branch"));
  },
  // updated() {
  //   // console.log("filter updated");
  // },
  methods: {
    formInitialized(e) {
      console.log("formInitialized ", e);
    },

    tagBoxValueChanged(e, data) {
      console.log("tagBoxValueChanged e ", e);
      console.log("tagBoxValueChanged data ", data);

      this.reportModel[data.dataField] = e.value;
    },

    filterDateRangeOptions(data) {
      var setItems = undefined;
      this.filterFormItems[0].items.forEach((element, i) => {
        if (element.gcType == "group") {
          let index = element.items.findIndex(
            (x) => x.dataField == data.dataField
          );
          if (index > -1) {
            setItems = this.filterFormItems[0].items[i].items[index];
          }
        }
      });

      let optionItems = [];
      if (setItems) {
        if (setItems.operators)
          setItems.operators.forEach((operator) => {
            let x = this.searchOptionItems.findIndex(
              (i) => i.value == operator
            );
            if (x > -1) optionItems.push(this.searchOptionItems[x]);
          });
      }

      return optionItems.length > 0 ? optionItems : this.searchOptionItems;
    },
    optionChanged(e, data) {
      if (e.name == "value") {
        if (e.value == null) {
          this.reportModel[data.dataField] = undefined;
          this.formRefresh();
        }
      }
    },
    formRefresh() {
      console.log(["FORM REFRESH"]);
      var form = this.$refs["filter-form"].instance;
      form.repaint(true);
    },
    clearDateIn(dataField) {
      this.reportModel[dataField] = undefined;
      this.reportModel[dataField + "To"] = undefined;

      this.formRefresh();
      this.createCustomFilter({ dataField: dataField }, undefined);
    },
    searchOptionItemClick(data, e) {
      this.searchOperatorIconModel[data.dataField] = e.itemData.icon;
      this.searchOperatorIconModel[data.dataField + "To"] = e.itemData.icon;
      this.getDateRangeModel[data.dataField] = e.itemData.value;
      this.getDateRangeModel[data.dataField + "To"] = e.itemData.value;

      this.reportModel[data.dataField + "To"] = this.reportModel[
        data.dataField
      ];

      this.formRefresh();
    },
    applyPopUpFilter() {
      this.tabletModeSelectPopupVisible = false;
      let grid = this.$refs["custom-popup-grid"].instance;
      this.selectedRowKeys = grid.getSelectedRowKeys();

      this.reportModel[this.tabletModeSelectedField] = this.selectedRowKeys;
    },
    customePopUpRowClick(e) {
      var grid = e.component;
      var rowKey = grid.getKeyByRowIndex(e.rowIndex);
      if (!e.isSelected) grid.selectRows(e.key, true);
      else grid.deselectRows([rowKey]);
    },

    selectPopUpToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "searchPanel";
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: 260,
            dataSource: SalesRepresentativeService.dataSourceConfig(
              "api/SalesRepresentative",
              {
                select: ["Code", "FirstName", "Surname"],
                filter: ["Inactive", "=", "N"],
                sort: [{ selector: "FirstName", asc: true }],
              }
            ),
            placeholder: "Sales Representative",
            valueExpr: "Code",
            value: this.defaultValue
              ? this.defaultValue["SalesRepresentativeCode"]
              : null,
            showClearButton: true,
            searchEnabled: false,
            displayExpr: function(data) {
              if (data) return data.FirstName + " " + data.Surname;
            },
            onValueChanged: (e) => {
              let grid = this.$refs["custom-popup-grid"].instance;
              if (e.value != null) {
                grid.filter([
                  ["SalesRepresentativeCode", "=", e.value],
                  "and",
                  ["Inactive", "=", "N"],
                ]);
              } else {
                grid.filter(["Inactive", "=", "N"]);
              }
            },
            showDataBeforeSearch: true,
          },
          visible:
            this.screenType == "sales-order-list" &&
            this.tabletModeSelectedField == "CustomerCode",
        },
        searchPanel
      );
    },
    onContentReady() {
      let grid = this.$refs["custom-popup-grid"].instance;
      grid.off("contentReady");
      grid.refresh(true);
      if (this.reportModel[this.tabletModeSelectedField]) {
        if (this.reportModel[this.tabletModeSelectedField].length != 0) {
          this.reportModel[this.tabletModeSelectedField].forEach((element) => {
            let i = this.selectedRowKeys.findIndex((x) => x == element);
            if (i < 0) this.selectedRowKeys.push(element);
          });
        }
      }
      setTimeout(() => {
        grid.on("contentReady", this.onContentReady);
      }, 1500);
    },
    customePopUpHidden() {
      let grid = this.$refs["custom-popup-grid"].instance;
      this.searchText = "";
      // grid.clearFilter();
      grid.option("columns", []);
      grid.option("dataSource", []);
      grid.repaint(true);

      this.tabletModeSelectPopupVisible = false;
    },
    async applyInternalFilter(type) {
      if (type == "clear") {
        this.filterCollection.length = 0;

        // if there is an initial filter, filter by that or else clear the datasource filter
        if (this.initialFilter.length > 0)
          this.dataSource.filter(this.initialFilter);
        else this.dataSource.filter(null);

        await this.dataSource.reload();
      } else {
        // apply

        let arr = [];
        if (this.advanceFilterArray.length > 0) {
          let parsedFilterParams = this.advanceFilterArray.map((x) => {
            // check if an item is a Date object
            if (Object.prototype.toString.call(x) === "[object Date]")
              // if so use the stringifyDate utility
              return JSON.parse(JSON.stringify(x, replacer));
            else return x;
          });

          arr.push(parsedFilterParams);
        }

        // if advanceFilterArray is not empty & there is an initialFilter push it to arr with a 'and' clause
        if (arr.length > 0) {
          if (this.initialFilter.length > 0) {
            arr.push("and");
            arr.push(this.initialFilter);
          }
        } // if advanceFilterArray  empty & there is an initialFilter push it to arr
        else {
          if (this.initialFilter.length > 0) arr.push(this.initialFilter);
        }

        // if arr is not empty filter by arr or if it is empty, remove the filter
        if (arr.length > 0) this.dataSource.filter(arr);
        else this.dataSource.filter(null);

        await this.dataSource.reload();
        return;
      }
    },
    clearAdvanceFilters() {
      Object.keys(this.reportModel).forEach(
        (key) => (this.reportModel[key] = undefined)
      );

      // if (this.reportModel["DateIn"]) this.reportModel["DateIn"] = undefined;
      // if (this.reportModel["DateInTo"])
      //   this.reportModel["DateInTo"] = undefined;
      // this.selectedSearchOptionIcon = "equal";
      // this.selectedSearchOption = "=";

      var form = this.$refs["filter-form"].instance;
      if (form) {
        form.resetValues();
      }
      form.repaint(true);
      this.dirty.isDirty = false;
      if (this.applyFilter) this.applyFilter("clear", []);
      else this.applyInternalFilter("clear");
    },

    createCustomFilter(filterField, e) {
      // console.log('filter field ', filterField, " e ", e);
      this.dirty.isDirty = true;

      // if (filterField.dataField == "DateIn") {
      //   this.formRefresh();
      // }

      let filter = [];
      var setFilter = [];

      if (e != undefined) {
        if (!e.event) {
          if (this.screenType != "sales-order-list") return;
          else if (!e.value) return;
          else if (e.value.length == 0) return;
        }
        if (Array.isArray(e.value)) {
          e.value.forEach((element) => {
            setFilter = [];
            setFilter[0] = filterField.dataField;
            setFilter[1] = "=";
            setFilter[2] = element;
            if (filter.length > 0) filter.push("or");
            filter.push(setFilter);
          });
        } else if (e.value) {
          if (
            this.screenType == "invoice-sales" &&
            (filterField.dataField == "DateGroup" ||
              filterField.dataField == "DateIn" ||
              filterField.dataField == "WeekStartDate" ||
              filterField.dataField == "FiscalPeriodId" ||
              filterField.dataField == "QuarterId" ||
              filterField.dataField == "Year" ||
              filterField.dataField == "FiscalYear")
          ) {
            setFilter = [];
          } else if (
            filterField.gcType == "Date" ||
            filterField.editorType == "dxDateBox"
          ) {
            this.reportModel[filterField.dataField] = e.value;
            this.formRefresh();

            if (
              this.getDateRangeModel &&
              this.getDateRangeModel[filterField.dataField] == "between"
            ) {
              if (
                !this.reportModel[filterField.dataField] ||
                !this.reportModel[filterField.gcRangeField]
              ) {
                return;
              }

              let date = new Date(
                filterField.gcFilterField
                  ? this.reportModel[filterField.gcRangeField]
                  : e.value
              ).toYYYYMMDD();
              setFilter = [];
              setFilter[0] = filterField.gcFilterField
                ? filterField.gcRangeField
                : filterField.dataField;
              setFilter[1] = ">=";
              setFilter[2] = new Date(date + "T00:00:00");
              filter.push(setFilter);
              filter.push("and");

              let setNextDay = new Date(
                filterField.gcFilterField
                  ? e.value
                  : this.reportModel[filterField.gcRangeField]
              )
                .addDays(1)
                .toYYYYMMDD();
              setFilter = [];
              setFilter[0] = filterField.gcFilterField
                ? filterField.gcRangeField
                : filterField.dataField;
              setFilter[1] = "<";
              setFilter[2] = new Date(setNextDay + "T00:00:00");
              filter.push(setFilter);
            } else if (
              this.getDateRangeModel &&
              this.getDateRangeModel[filterField.dataField] != "between" &&
                this.getDateRangeModel[filterField.dataField] != "="
            ) {
              let date = new Date(e.value).toYYYYMMDD();
              setFilter = [];
              setFilter[0] = filterField.dataField;
              setFilter[1] = this.getDateRangeModel[filterField.dataField];

              if (this.getDateRangeModel[filterField.dataField] == "<=") {
                setFilter[1] = "<";
                date = new Date(e.value).addDays(1).toYYYYMMDD();
              }
              if (
                this.getDateRangeModel[filterField.dataField] == ">" ||
                this.getDateRangeModel[filterField.dataField] == ">="
              ) {
                setFilter[1] = ">=";
                date = new Date(e.value).addDays(1).toYYYYMMDD();
                if (this.getDateRangeModel[filterField.dataField] == ">=")
                  date = new Date(e.value).toYYYYMMDD();
              }
              setFilter[2] = new Date(date + "T00:00:00");
              filter.push(setFilter);
            } else {
              let date = new Date(e.value).toYYYYMMDD();
              if (filterField.hasOwnProperty("operator")) {
                setFilter = [];
                setFilter[0] = filterField.dataField;
                setFilter[1] = filterField.operator; // TODO: May be deprecated in the future. This is a temporary fix to cater single operator like >,>=,<,<= on date
                setFilter[2] = new Date(date + "T00:00:00");
                filter.push(setFilter);
              } else {
                setFilter = [];
                setFilter[0] = filterField.dataField;
                setFilter[1] = ">=";
                setFilter[2] = new Date(date + "T00:00:00");
                filter.push(setFilter);
                filter.push("and");

                let setNextDay = new Date(date).addDays(1).toYYYYMMDD();
                setFilter = [];
                setFilter[0] = filterField.dataField;
                setFilter[1] = "<";
                setFilter[2] = new Date(setNextDay + "T00:00:00");
                filter.push(setFilter);
              }
            }
          } // if (filterField.dataField != "FiscalYear" && filterField.dataField != "FiscalPeriod")
          else {
            setFilter = [];
            setFilter[0] = filterField.dataField;
            setFilter[1] = "=";
            setFilter[2] = e.value;
            filter.push(setFilter);
          }
        }
      }

      if (this.filterCollection.length > 0) {
        let matchField = filterField.gcFilterField
          ? filterField.gcRangeField
          : filterField.dataField;
        let index = this.filterCollection.findIndex(
          (x) => x[0][0] == matchField
        );
        if (index > -1) {
          if (this.filterCollection[index + 1] == "and") {
            this.filterCollection.splice(index, 2);
          } else {
            this.filterCollection.splice(index, 1);
          }
        }
        // after the splice event

        if (
          this.filterCollection.length > 0 &&
          this.filterCollection[this.filterCollection.length - 1] != "and"
        )
          this.filterCollection.push("and");
      }

      if (filter.length > 0) {
        this.filterCollection.push(filter);
      }

      if (this.filterCollection[this.filterCollection.length - 1] == "and") {
        this.filterCollection.splice(this.filterCollection.length - 1, 1);
      }
      // }
      console.log("this.filterCollection ", this.filterCollection);

      // this.filterCallBack(this.filterCollection, filterField.dataField, e);
    },

    applyCustomFilter() {
      this.dirty.isDirty = false;
      if (this.applyFilter) this.applyFilter("apply", this.filterCollection);
      else this.applyInternalFilter("apply");
    },

    // / JSOM Format

    getOptions(dataField) {
      var items = this.filterFormItems.filter((x) => x.name == dataField);

      if (this.filterModel) {
        var value = this.filterModel[items[0].name];
        if (value) {
          items[0].editorOptions.defaultValue = value;
        }
      }

      return items[0].editorOptions;
    },
    async onFocusEvent(element) {
      this.tabletModeSelectPopupVisible = true;
      var grid = this.$refs["custom-popup-grid"].instance;
      this.tabletModeSelectedField = element.dataField;
      this.tabletModeSelectPopupTitle = element.gcLabel + " Search";
      this.tabletViewSelectColumns = element.editorOptions.columns;
      grid.option("columns", this.tabletViewSelectColumns);

      if (element.editorOptions.items) {
        this.keyExpr = element.editorOptions.valueExpr;
        this.tabletModeDataSourceConfig = element.editorOptions.items;
        grid.option("dataSource", this.tabletModeDataSourceConfig);
      } else {
        this.keyExpr = undefined;
        this.tabletModeDataSourceConfig = element.editorOptions.dataSource;
        grid.option("dataSource", this.tabletModeDataSourceConfig);
        this.tabletModeDataSourceConfig.load().then(() => {
          grid.repaint(true);
        });
      }
    },
    selectSearchicon(data) {
      return this.searchOperatorIconModel[data.dataField]
        ? this.searchOperatorIconModel[data.dataField]
        : "equal";
    },
  },
  computed: {
    dateInClearBtn() {
      return {
        icon: "clear",
        type: "clear",
        template: "date-in-clear",
        elementAttr: { class: "date-in-clear dx-clear-button-area" },
        // visible: this.reportModel[data.dataField] != undefined,
        visible: true,
      };
    },
    getDateRangeModel() {
      return this.dateRangeModel;
    },
    columns() {
      return this.tabletViewSelectColumns;
    },
    applyButtonLabel() {
      if (this.dirty.isDirty) {
        return "Apply-v2";
      } else {
        return "Refresh-v2";
      }
    },
    filterPanelTabOptions() {
      return {
        dataSource: this.sideBarTabs,
        // onItemClick: this.changeFilterPanelTab,
        selectedIndex: this.sidebarTabSelectedIndex,
      };
    },
    filterCollection() {
      return this.advanceFilterArray;
    },

    // / JSON Format

    reportModel() {
      let model = {};
      this.filterFormItems.forEach((el) => {
        let key = el.name;
        model[key] = [];
      });

      return this.isJson ? model : this.filterModel;
    },

    jSonFormItems() {
      console.log("$$$$$$$$$$$$$$$$$$$$$$");
      let formFields = [];
      if (this.isJson) {
        formFields = [
          {
            itemType: "group",
            caption: "",
            items: this.filterFormItems.map((option) => {
              let el = {};
              el.dataField = option.name;
              el.template = option.Editor;
              el.label = { text: option.label };
              el.editorType = option.editorOptions.editorType;
              el.editorOptions = option.editorOptions;
              el.visible = !option.visible ? option.visible : true;
              el.ref = option.name;
              return el;
            }),
          },
        ];
      } else {
        this.filterFormItems[0].items.forEach((element) => {
          if (element.gcType != "group") {
            if (
              element.gcType != "Date" &&
              this.screenType == "sales-order-list"
            )
              element.editorOptions.onFocusIn = this.isTablet
                ? this.onFocusEvent.bind(this, element)
                : null;
            // element.editorOptions.onSelectionChanged = this.onSelectionChanged.bind(this, element);

            if (element.gcLayout) {
              element.editorOptions = ReportLayOut.getReportLayout(
                element.gcLayout
              );
            }

            if (element.editorType == "dxButton") {
              element.editorOptions.text = this.dirty.isDirty
                ? "Apply"
                : "Refresh";
              console.log("******* ", element);
            } else {
              element.editorOptions.onValueChanged = this.createCustomFilter.bind(
                this,
                element
              );
            }

            // console.log("******* " , element);
          } else {
            element.items.forEach((item) => {
              item.editorOptions.onValueChanged = this.createCustomFilter.bind(
                this,
                item
              );
              if (
                (item.gcType != "Date" || item.editorType == "dxDateBox") &&
                this.screenType == "sales-order-list"
              )
                item.editorOptions.onFocusIn = this.isTablet
                  ? this.onFocusEvent.bind(this, item)
                  : null;

              if (item.template == "date-in-to-template") {
                item.visible =
                  this.getDateRangeModel[
                    item.dataField.toString().replace("To", "")
                  ] == "between";
                element.colCount =
                  this.getDateRangeModel[
                    item.dataField.toString().replace("To", "")
                  ] == "between"
                    ? 2
                    : 1;
              } else {
                element.colCount = 1;
              }
            });
          }
        });
      }

      return this.isJson ? formFields : this.filterFormItems;
    },
  },
};
</script>

<style lang="scss">
// @import "../assets/styles/global.scss";

.advance-filter-panel {
  .responsive-paddings {
    padding-right: 5px !important;
  }

  .view-card {
    margin-bottom: 0px !important;
  }
  .dx-form {
    padding-bottom: 20px;
  }
  .form-footer {
    display: flex;
    justify-content: flex-end;
    // margin-bottom: 15px;
    // margin-right: 5px;
  }

  .header-btns {
    padding-bottom: 5px;
    .apply-btn {
      margin-right: 5px;
    }

    .dx-button {
      width: calc(50% - 3px);
    }
  }

  .search-option {
    .dx-icon {
      margin-bottom: 8px;
      margin-right: 0 !important;
    }
    .dx-button-text {
      display: none;
    }

    .dx-button-mode-text.dx-button.dx-buttongroup-item:hover {
      background-color: unset;
    }
  }

  .add-icon {
    padding-right: 0 !important;
  }

  .date-in-to-group {
    padding-left: 0 !important;
    display: inline-flex;
    justify-content: flex-end;

    .date-in-to {
      display: inline-flex;
      padding-top: 35px;
      span {
        vertical-align: middle;
        align-self: center;
        padding-right: 10px;
        padding-left: 5px;
      }
    }
  }

  .date-in-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;

    .dx-icon-clear {
      color: rgba(117, 117, 117, 0.87);
      background-color: rgba(194, 194, 194, 0.87);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      margin-top: -11px !important;
      width: 22px;
      height: 22px;
      background-position: 0 0;
      background-size: 12px 12px;
      padding: 0;
      font-size: 12px;
      text-align: center;
      line-height: 12px;
    }
    .dx-icon-clear::before {
      position: absolute;
      display: block;
      width: 12px;
      height: 12px;
      top: 50%;
      margin-top: -6px;
      left: 50%;
      margin-left: -6px;
    }

    .dx-inkripple .dx-inkripple-wave {
      width: 22px !important;
      height: 22px !important;
      opacity: 1 !important;
      top: 3px !important;
      left: 2px !important;
    }
  }

  .date-in-clear:hover,
  .date-in-clear:focus {
    background-color: unset;
  }
  .date-in-clear.dx-state-active {
    background-color: unset;
  }
}
</style>
